const supportedLanguages = ['pl', 'en']

export default supportedLanguages
